import type { MediaKind } from './mediaFileTypes';
import { previewFileUrl } from '../fileBrowser/fileBrowserApi';

export function mediaPreviewSrc(mountId: string, relativePath: string): string {
  return previewFileUrl(mountId, relativePath);
}

export function mediaViewerPath(kind: MediaKind): string {
  return kind === 'image' ? '/files/image-viewer' : '/files/video-viewer';
}

export function buildMediaViewerSearch(mountId: string, relativePath: string): string {
  const params = new URLSearchParams();
  params.set('mountId', mountId);
  params.set('path', relativePath);
  return params.toString();
}

export function mediaViewerHref(kind: MediaKind, mountId: string, relativePath: string): string {
  return `${mediaViewerPath(kind)}?${buildMediaViewerSearch(mountId, relativePath)}`;
}
